<template>
  <Dashboard title="Export">
    <div
      id="export"
      v-if="selectedApplicationId"
    >
      <h3>Statistics</h3>

      <Background>
        <form>
          <div class="row">
            <!-- <div class="input col-24">
              <p>Intervention</p>

              <select
                name="intervation"
                v-model="exportForm.intervention"
              >
                <option
                  v-for="(item, index) of applications"
                  v-bind:key="index"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </select>
            </div> -->

            <div class="input col-24">
              <p>Modules</p>

              <select
                name="module"
                v-model="exportForm.module"
              >
                <option value="Events">Events</option>
                <option value="Users">Users</option>
              </select>
            </div>

            <div class="input col-12">
              <p>From</p>

              <datepicker
                :monday-first="true"
                format="d MMMM yyyy"
                value-format="yyyy-MM-dd"
                v-model="exportForm.startdate"
                :use-utc="true"
              />
            </div>

            <div class="input col-12">
              <p>Till</p>

              <datepicker
                :monday-first="true"
                format="d MMMM yyyy"
                value-format="yyyy-MM-dd"
                v-model="exportForm.enddate"
                :use-utc="true"
              />
            </div>
          </div>

          <Button
            title="Generate export"
            active=true
            to=""
            class="statistics-button"
            v-on:handleClick="handleExportStatistics"
            v-if="!statisticsError"
          />

          <Loading
            class="loading"
            v-if="statisticsError"
          />

          <p class="error-message">{{ statisticsErrorMessage }}</p>
        </form>
      </Background>

      <h3
        v-if="questionnaires.length > 0"
        class="export--questions-title"
      >
        Questionnaires
      </h3>

      <Background
        v-if="questionnaires.length > 0"
      >
        <form>
          <div class="row">
            <div class="input col-24">
              <p>Questionnaire ID</p>

              <select
                name="intervation"
                v-model="exportQuestionnaires.questionnaireid"
              >
                <option
                  v-for="(item, index) of questionnaires"
                  v-bind:key="index"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>

            <div class="input col-24">
              <p>Modules</p>

              <select
                name="module"
                v-model="exportQuestionnaires.module"
              >
                <option value="questions">Questions</option>
                <option value="answers">Answers</option>
              </select>
            </div>

            <div class="input col-12">
              <p>From</p>

              <datepicker
                :monday-first="true"
                format="d MMMM yyyy"
                value-format="yyyy-MM-dd"
                v-model="exportQuestionnaires.startdate"
                :use-utc="true"
              />
            </div>

            <div class="input col-12">
              <p>Till</p>

              <datepicker
                :monday-first="true"
                format="d MMMM yyyy"
                value-format="yyyy-MM-dd"
                v-model="exportQuestionnaires.enddate"
                :use-utc="true"
              />
            </div>
          </div>

          <Button
            title="Generate export"
            active=true
            to=""
            class="questionnaires-button"
            v-on:handleClick="handleExportQuestionnaires"
            v-if="!questionnairesError"
          />

          <Loading
            class="loading"
            v-if="questionnairesError"
          />

          <p class="error-message">{{ questionnairesErrorMessage }}</p>
        </form>
      </Background>
    </div>

    <NoApplicationSelected v-else/>
  </Dashboard>
</template>

<script>
  import { API } from '../../services/api.ts'
  import Dashboard from '../../components/dashboard/dashboard.vue'
  import Background from '../../components/background/background.vue'
  import Input from '../../components/form/input.vue'
  import Button from '../../components/buttons/button.vue'
  import NoApplicationSelected from '../../components/error/noApplicationSelected.vue'
  import Datepicker from 'vuejs-datepicker'
  import moment from 'moment';
  import Loading from '../../components/loading/loading.vue';

  export default {
    name: 'Export',
    components: {
      Dashboard,
      Background,
      Input,
      Button,
      NoApplicationSelected,
      Datepicker,
      Loading,
    },
    data() {
      return {
        selectedApplicationId: localStorage.selectedApplicationId,
        applications: [],
        questionnaires: [],
        exportForm: {
          intervention: localStorage.selectedApplicationId,
          module: 'Events',
          startdate: '',
          enddate: '',
        },
        exportQuestionnaires: {
          questionnaireid: 0,
          module: 'questions',
          startdate: '',
          enddate: '',
        },
        statisticsError: false,
        statisticsErrorMessage: '',
        questionnairesError: false,
        questionnairesErrorMessage: '',
      }
    },
    methods: {
      handleExportStatistics: function() {
        const statisticsButton = document.querySelector('.statistics-button');

        statisticsButton.style.backgroundColor = '#2F2F82';

        this.statisticsErrorMessage = '';
        this.statisticsError = true;

        API.post(
          `index.cfm?act=export.statistics`,
          {
            applicationid: this.exportForm.intervention,
            module: this.exportForm.module,
            startdate: moment.utc(this.exportForm.startdate, 'YYYY-MM-DD').format('YYYY-MM-DD'),
            enddate: moment.utc(this.exportForm.enddate, 'YYYY-MM-DD').format('YYYY-MM-DD'),
          },
        ).then(
          response => {
            // Retrieve filename from the content-disposition header
            const disposition = response.headers['content-disposition'];
            var fileDate = moment().format('YYYYMMDD_HHmmss');
            var fileName = `statistics-${fileDate}.csv`;

            if (disposition && disposition.indexOf('attachment') !== -1) {
              const filenameRegex = /filename=((['"]).?\2|[^;\n]*)/;
              const matches = filenameRegex.exec(disposition)
              if (matches != null && matches[1]) {
                fileName = matches[1].replace(/['"]/g, '')
              }
            }

            var url = window.URL.createObjectURL(new Blob([response.data], {type: 'text/csv;charset=utf-8'}));
            var link = document.createElement('a');

            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            statisticsButton.style.backgroundColor = 'var(--blue)';
            this.statisticsError = false;
            this.statisticsErrorMessage = '';
          }
        ).catch((error) => {
          statisticsButton.style.backgroundColor = 'var(--blue)';
          this.statisticsError = false;
          this.statisticsErrorMessage = 'Loading data failed';
        });
      },
      handleExportQuestionnaires: function() {
        const questionnairesButton = document.querySelector('.questionnaires-button');

        questionnairesButton.style.backgroundColor = '#2F2F82';

        this.questionnairesErrorMessage = '';
        this.questionnairesError = true;

        API.post(
          `index.cfm?act=export.questionnaire`,
          {
            questionnaireid: this.exportQuestionnaires.questionnaireid,
            module: this.exportQuestionnaires.module,
            startdate: moment.utc(this.exportQuestionnaires.startdate, 'YYYY-MM-DD').format('YYYY-MM-DD'),
            enddate: moment.utc(this.exportQuestionnaires.enddate, 'YYYY-MM-DD').format('YYYY-MM-DD'),
          },
        ).then(
          response => {
            // Retrieve filename from the content-disposition header
            const disposition = response.headers['content-disposition'];
            var fileDate = moment().format('YYYYMMDD_HHmmss');
            var fileName = `questionnaires-${fileDate}.csv`;

            if (disposition && disposition.indexOf('attachment') !== -1) {
              const filenameRegex = /filename=((['"]).?\2|[^;\n]*)/;
              const matches = filenameRegex.exec(disposition)
              if (matches != null && matches[1]) {
                fileName = matches[1].replace(/['"]/g, '')
              }
            }

            var url = window.URL.createObjectURL(new Blob([response.data], {type: 'text/csv;charset=utf-8'}));
            var link = document.createElement('a');

            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            questionnairesButton.style.backgroundColor = 'var(--blue)';
            this.questionnairesError = false;
            this.questionnairesErrorMessage = '';
          }
        ).catch((error) => {
          statisticsButton.style.backgroundColor = 'var(--blue)';
          this.questionnairesError = false;
          this.questionnairesErrorMessage = 'Loading data failed';
        });
      }
    },
    mounted() {
      const self = this;

      API.get(
        `index.cfm?act=applications.list`
      ).then(
        response => {
          this.applications = response.data.data;
        }
      ).catch(function (error) {
        if (error.response.status === 403) {
          localStorage.removeItem('selectedApplicationName');
          localStorage.removeItem('selectedApplicationId');
          self.selectedApplicationId = null
        }
      });

      API.get(
      'index.cfm?act=questionnaires.list'
      ).then(
        response => {
          console.log(response.data.data);
          this.questionnaires = response.data.data;
          this.isLoading = false;
        }
      ).catch(function (error) {
        if (error.response.status === 403) {
          localStorage.removeItem('selectedApplicationName');
          localStorage.removeItem('selectedApplicationId');
          self.selectedApplicationId = null
        }
      });
    }
  }
</script>

<style lang="scss">
  #export {

    .export--questions-title {
      margin-top: 30px;
    }

    input {
      width: 100%;
      max-width: 100%;
    }

    select {
      width: 100%;
      height: 30px;
      border: 1px solid var(--blue-medium);
      background: #fff;
      outline: 0;
      border-radius: 0;
    }

    select:not([multiple]) {
      -webkit-appearance: none;
      -moz-appearance: none;
      background-position: right 50%;
      background-repeat: no-repeat;
      background-image: url('data:image/svg+xml;utf8,<?xml version="1.0" encoding="utf-8"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" version="1"><path d="M4 8L0 4h8z"/></svg>');
      padding: .5em;
      padding-right: 1.5em
    }

    .button-bgcolor {

      &:focus {
        background-color: red;
      }
    }

    .loading,
    .error-message {
      margin-top: 10px;
    }

    .statistics-button,
    .questionnaires-button,
    .error-message {
      display: inline-block;
    }

    .error-message {
      margin-left: 10px;
    }
  }
</style>